import { useEffect, useState } from 'react';
import { fetchSampleStory } from '@/utils/api';
import { highlightStoryTokens } from '@/utils/storyHighlights';

const FALLBACK_TITLE = 'Aarav and the Magical Valley of Ancient Wonders';
const FALLBACK_BODY = `One warm evening, a boy named Aarav was practising his football kicks in the garden when the ball disappeared into golden mist. In the mist stood Ganesha, radiant and patient, his trunk curled in a gentle smile.`;

export const StoryPreviewCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchSampleStory().then((s) => { if (mounted) setData(s); }).catch(() => {
      if (mounted) setData({ title: FALLBACK_TITLE, body: FALLBACK_BODY });
    });
    return () => { mounted = false; };
  }, []);

  const title = data?.title || FALLBACK_TITLE;
  const body = data?.body || FALLBACK_BODY;
  const words = body.split(/\s+/);
  const previewText = words.slice(0, 55).join(' ') + (words.length > 55 ? '…' : '');

  const highlighted = highlightStoryTokens(previewText, {
    childName: 'Aarav',
    deityName: 'Ganesha',
    interests: ['football', 'dinosaurs'],
  });

  return (
    <div
      data-testid="landing-sample-story-preview"
      className="relative mx-auto mt-8 max-w-md w-full rounded-tlLg border border-tl-border bg-tl-card/95 shadow-tl-float p-5 animate-tl-story-float"
    >
      <div className="flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.14em] text-tl-gold">Hindu mythology</span>
        <span className="text-tl-textSecondaryOnDark text-[10px]">· sample</span>
      </div>
      <div className="mt-2 text-white text-[15px] font-semibold font-story" data-testid="landing-sample-title">{title}</div>
      <div className="mt-1 text-[11px] text-tl-textSecondaryOnDark">for Aarav · with Ganesha · 5–7 years</div>
      <p
        className="mt-3 text-[13px] leading-6 text-white/90 font-story"
        data-testid="landing-sample-body"
        dangerouslySetInnerHTML={{ __html: highlighted }}
      />
    </div>
  );
};
